import { AudienceOptions, SendOptions } from '../../../../../../modals/push-notifications/campaign/Constants';

export default {
  title: 'Crear campaña de notificación push',
  sent_title: 'Notificación en cola',
  sent_subtitle:
    'Tu notificación push ha sido enviada a Apple y Google. Las confirmaciones de entrega llegan en unos 15 minutos.',
  sent_info_banner:
    'Puedes cerrar este diálogo. Seguiremos verificando y actualizando las estadísticas de entrega automáticamente.',
  circles: {
    sent_label: 'Enviado',
    sent_sub: 'Enviado a suscriptores',
    delivered_label: 'Entregado',
    delivered_sub: 'Esperando a Apple y Google',
    delivered_ready_short: 'Listo',
    delivered_ready_sub: 'Actualiza para ver las últimas estadísticas',
  },
  scheduled_title: 'Campaña programada',
  scheduled_body_line_1: 'Tu notificación push está programada para {{when}}.',
  scheduled_body_line_2:
    'La enviaremos automáticamente a esa hora. Las confirmaciones de entrega de Apple y Google están disponibles unos 15 minutos después del envío.',
  recipients_count_one: 'Enviado a {{count}} suscriptor.',
  recipients_count_other: 'Enviado a {{count}} suscriptores.',
  close: 'Cerrar',
  sections: {
    message: 'Mensaje',
    audience: 'Audiencia',
    when: 'Cuándo enviar',
    review: 'Revisar',
  },
  stepper: {
    message: 'Mensaje',
    audience_when: 'Cuándo enviar',
    review: 'Revisar',
  },
  blocked_reasons: {
    title_required: 'Añade un título para continuar.',
    body_required: 'Añade el cuerpo del mensaje para continuar.',
    offer_required: 'Selecciona una oferta para continuar.',
    promo_code_required: 'Selecciona un código promo para continuar.',
    send_option_required: 'Elige cuándo enviar para continuar.',
    scheduled_at_required: 'Selecciona fecha y hora para continuar.',
  },
  fields: {
    title: {
      label: 'Título',
      placeholder: 'Introduce el título de la notificación',
    },
    body: {
      label: 'Cuerpo del mensaje',
      placeholder: 'Introduce tu mensaje',
    },
    audience: {
      label: 'Audiencia',
    },
    send_options: {
      label: 'Opciones de envío',
    },
    date_and_time: {
      label: 'Fecha y hora',
      placeholder: 'Selecciona fecha y hora',
    },
  },
  send_options: {
    [SendOptions.Now]: 'Enviar ahora',
    [SendOptions.Schedule]: 'Programar',
  },
  send_option_cards: {
    now: {
      title: 'Enviar ahora',
      description: 'Enviar a todos los suscriptores de inmediato.',
    },
    schedule: {
      title: 'Programar',
      description: 'Elige una fecha y hora en el futuro.',
    },
  },
  campaign_type_cards: {
    promotional: {
      title: 'Promocional 🚀',
      description: 'Promociona una oferta o un código promo.',
    },
    informational: {
      title: 'Informacional ℹ️',
      description: 'Comparte noticias o una actualización — sin descuento.',
    },
  },
  audience: {
    [AudienceOptions.All]: 'Todos los usuarios ({{count}} dispositivo)',
  },
  preview: {
    title: 'Vista previa',
    notifications: {
      title: 'El título de tu notificación aparecerá aquí',
      body: 'El cuerpo de tu mensaje se mostrará aquí con todos los detalles...',
      now: 'Ahora',
    },
    estimated_reach: 'Alcance',
  },
  summary: {
    title: 'Resumen',
    reach: 'Alcance',
    when: 'Cuándo',
    campaign_type: 'Tipo de campaña',
    promo_code: 'Código promo',
    offer: 'Oferta',
    test_audience: 'Envía primero un push de prueba',
  },
  alerts: {
    daily_limit_reached: {
      title: 'Límite diario de envíos alcanzado',
      description:
        '¡Atención! Enviar más de 1 notificación push al día incomoda a los usuarios y puede llevar a desinstalar la app. Por eso limitamos los envíos manuales a 1/día. Por favor, prográmalo para mañana.',
    },
    offer_not_sendable: {
      title: 'La oferta no está activa hoy',
      description: 'Por favor, elige una fecha en el futuro.',
    },
  },
  buttons: {
    send_now: 'Enviar ahora',
    save: 'Guardar',
    save_as_draft: 'Guardar como borrador',
    send_test: 'Enviar prueba',
    draft_with_ai: 'Redactar con IA',
    back: 'Atrás',
    next: 'Siguiente',
  },
  feedback: {
    success: 'Campaña guardada con éxito',
    promo_code_expired: 'Código promo vencido',
    error: 'No se pudo guardar la campaña. Comprueba tu conexión e inténtalo de nuevo.',
  },
};
